import { LABELS } from './flatfileLabels'
import getColumnWidth from '../utils/getFlatfileColumnWidth'
import { notificationServicesFields } from './notificationsFields'

export const getNotificationsParticipantFields = (userAudience) => [
  {
    key: 'recordkeeper',
    label: LABELS.RECORDKEEPER,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'recordKeeper' },
    ],
    appearance: { size: getColumnWidth(LABELS.RECORDKEEPER) },
  },
  {
    key: 'tpa',
    label: LABELS.THIRD_PARTY_ADMINISTRATOR,
    type: 'string',
    constraints:
      userAudience === 'Recordkeeper'
        ? [{ type: 'external', validator: 'tpa' }]
        : [{ type: 'required' }, { type: 'external', validator: 'tpa' }],
    appearance: { size: getColumnWidth(LABELS.THIRD_PARTY_ADMINISTRATOR) },
  },
  {
    key: 'planSponsor',
    label: LABELS.PLAN_SPONSOR,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planSponsor' },
    ],
    appearance: { size: getColumnWidth(LABELS.PLAN_SPONSOR) },
  },
  {
    key: 'planName',
    label: LABELS.COMPLETE_LEGAL_PLAN_NAME,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planName' },
    ],
    appearance: { size: getColumnWidth(LABELS.COMPLETE_LEGAL_PLAN_NAME) },
  },
  {
    key: 'planEin',
    label: LABELS.EMPLOYER_IDENTIFICATION_NUMBER,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planEin' },
    ],
    appearance: { size: getColumnWidth(LABELS.EMPLOYER_IDENTIFICATION_NUMBER) },
  },
  {
    key: 'planNumber',
    label: LABELS.THREE_DIGIT_PLAN_NUMBER,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planNumber' },
    ],
    appearance: { size: getColumnWidth(LABELS.THREE_DIGIT_PLAN_NUMBER) },
  },
  {
    key: 'planIdNumber',
    label: LABELS.PROVIDER_PLAN_ID_NUMBER,
    type: 'string',
    constraints: [{ type: 'external', validator: 'planIdNumber' }],
    appearance: { size: getColumnWidth(LABELS.PROVIDER_PLAN_ID_NUMBER) },
  },
  {
    key: 'firstName',
    label: LABELS.FIRST_NAME,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'firstName' },
    ],
    appearance: { size: getColumnWidth(LABELS.FIRST_NAME) },
  },
  {
    key: 'middleName',
    label: LABELS.MIDDLE_NAME,
    type: 'string',
    constraints: [{ type: 'external', validator: 'middleName' }],
    appearance: { size: getColumnWidth(LABELS.MIDDLE_NAME) },
  },
  {
    key: 'lastName',
    label: LABELS.LAST_NAME,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'lastName' },
    ],
    appearance: { size: getColumnWidth(LABELS.LAST_NAME) },
  },
  {
    key: 'addressLine1',
    label: LABELS.ADDRESS_LINE_1,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'addressLine1' },
    ],
    appearance: { size: getColumnWidth(LABELS.ADDRESS_LINE_1) },
  },
  {
    key: 'addressLine2',
    label: LABELS.ADDRESS_LINE_2,
    type: 'string',
    constraints: [{ type: 'external', validator: 'addressLine2' }],
    appearance: { size: getColumnWidth(LABELS.ADDRESS_LINE_2) },
  },
  {
    key: 'city',
    label: LABELS.CITY,
    type: 'string',
    constraints: [{ type: 'external', validator: 'city' }],
    appearance: { size: getColumnWidth(LABELS.CITY) },
  },
  {
    key: 'state',
    label: LABELS.STATE,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'state' },
    ],
    appearance: { size: getColumnWidth(LABELS.STATE) },
  },
  {
    key: 'zipCode',
    label: LABELS.ZIP_CODE,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'zipCode' },
    ],
    appearance: { size: getColumnWidth(LABELS.ZIP_CODE) },
  },
  {
    key: 'countryCode',
    label: LABELS.COUNTRY_CODE,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'countryCode' },
    ],
    appearance: { size: getColumnWidth(LABELS.COUNTRY_CODE) },
  },
  {
    key: 'emailAddress',
    label: LABELS.EMAIL_ADDRESS,
    type: 'string',
    constraints: [{ type: 'external', validator: 'emailAddress' }],
    appearance: { size: getColumnWidth(LABELS.EMAIL_ADDRESS) },
  },
  {
    key: notificationServicesFields.BAL_VESTED.key,
    label: notificationServicesFields.BAL_VESTED.label,
    type: 'string',
    constraints: [
      {
        type: 'external',
        validator: notificationServicesFields.BAL_VESTED.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.BAL_VESTED.label),
    },
  },
  {
    key: notificationServicesFields.BAL_TOTAL.key,
    label: notificationServicesFields.BAL_TOTAL.label,
    type: 'string',
    constraints: [
      { type: 'external', validator: notificationServicesFields.BAL_TOTAL.key },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.BAL_TOTAL.label),
    },
  },
  {
    key: notificationServicesFields.DATE_OF_BALANCE.key,
    label: notificationServicesFields.DATE_OF_BALANCE.label,
    type: 'string',
    constraints: [{ type: 'required' }],
    appearance: {
      size: getColumnWidth(notificationServicesFields.DATE_OF_BALANCE.label),
    },
  },
  {
    key: notificationServicesFields.REASON_ROLLOUT_REQ.key,
    label: notificationServicesFields.REASON_ROLLOUT_REQ.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.REASON_ROLLOUT_REQ.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.REASON_ROLLOUT_REQ.label),
    },
  },
  {
    key: notificationServicesFields.GRACE_PERIOD_TO_RESPOND.key,
    label: notificationServicesFields.GRACE_PERIOD_TO_RESPOND.label,
    type: 'string',
    constraints: [
      {
        type: 'required',
        config: {
          message: 'Value must be 30, 35, 40, 45, 60, or 90',
          level: 'error',
        },
      },
      {
        type: 'external',
        validator: notificationServicesFields.GRACE_PERIOD_TO_RESPOND.key,
      },
    ],
    appearance: {
      size: getColumnWidth(
        notificationServicesFields.GRACE_PERIOD_TO_RESPOND.label
      ),
    },
  },
  {
    key: notificationServicesFields.COMPANY_NAME.key,
    label: notificationServicesFields.COMPANY_NAME.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_NAME.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_NAME.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_ADDRESS_1.key,
    label: notificationServicesFields.COMPANY_ADDRESS_1.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_ADDRESS_1.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_ADDRESS_1.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_ADDRESS_2.key,
    label: notificationServicesFields.COMPANY_ADDRESS_2.label,
    type: 'string',
    constraints: [
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_ADDRESS_2.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_ADDRESS_2.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_CITY.key,
    label: notificationServicesFields.COMPANY_CITY.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_CITY.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_CITY.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_STATE.key,
    label: notificationServicesFields.COMPANY_STATE.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_STATE.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_STATE.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_ZIP.key,
    label: notificationServicesFields.COMPANY_ZIP.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_ZIP.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_ZIP.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_CONTACT_PHONE.key,
    label: notificationServicesFields.COMPANY_CONTACT_PHONE.label,
    type: 'string',
    constraints: [
      { type: 'required' },
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_CONTACT_PHONE.key,
      },
    ],
    appearance: {
      size: getColumnWidth(
        notificationServicesFields.COMPANY_CONTACT_PHONE.label
      ),
    },
  },
  {
    key: notificationServicesFields.COMPANY_WEBSITE.key,
    label: notificationServicesFields.COMPANY_WEBSITE.label,
    type: 'string',
    constraints: [
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_WEBSITE.key,
      },
    ],
    appearance: {
      size: getColumnWidth(notificationServicesFields.COMPANY_WEBSITE.label),
    },
  },
  {
    key: notificationServicesFields.COMPANY_CONTACT_EMAIL.key,
    label: notificationServicesFields.COMPANY_CONTACT_EMAIL.label,
    type: 'string',
    constraints: [
      {
        type: 'external',
        validator: notificationServicesFields.COMPANY_CONTACT_EMAIL.key,
      },
    ],
    appearance: {
      size: getColumnWidth(
        notificationServicesFields.COMPANY_CONTACT_EMAIL.label
      ),
    },
  },
]
